import React from 'react'

const Pointer = () => {
  const cls2 = {
    fill: 'none',
    stroke: '#fff',
    strokeLinecap: 'round',
    strokeMiterlimit: 10,
    strokeWidth: '4px',
  }
  const cls3 = cls2

  return (
    <svg viewBox="0 0 98.161 100.303">
      <g id="Group_1" dataName="Group 1" transform="translate(-823 -1267)">
        <g
          id="icons_dark_65x65_close_copy_2"
          dataName="icons/dark/65x65/close copy 2"
          transform="translate(823 1267)"
        >
          <rect
            id="icons_dark_65x65_close_copy_2_background"
            dataName="icons/dark/65x65/close copy 2 background"
            className="cls-1"
            width="98"
            height="93.072"
            fill="none"
          />
          <path
            id="Combined_Shape"
            dataName="Combined Shape"
            className="cls-2"
            style={cls3}
            d="M24.737,69.539l-5.69-.144-.626-24.53L1.248,48.9,23.961.606,47.726,50.588l-17.4-4.907L30.937,69.7Z"
            transform="translate(15.392 46.306) rotate(-40)"
          />
          <g
            id="Group_2"
            dataName="Group 2"
            transform="matrix(-0.174, 0.985, -0.985, -0.174, 55.012, 12.255)"
          >
            <path
              id="Path_14"
              dataName="Path 14"
              className="cls-3"
              style={cls3}
              d="M0,0,.1,11.731"
              transform="translate(19.064 0.172)"
            />
            <path
              id="Path_14_Copy"
              dataName="Path 14 Copy"
              className="cls-3"
              style={cls3}
              d="M0,0,.1,11.731"
              transform="translate(19.323 30.28)"
            />
            <g id="Group" transform="translate(40.034 20.683) rotate(90)">
              <path
                id="Path_14_Copy_3"
                dataName="Path 14 Copy 3"
                className="cls-3"
                style={cls3}
                d="M.1,0,0,11.176"
                transform="translate(-0.101)"
              />
              <path
                id="Path_14_Copy_2"
                dataName="Path 14 Copy 2"
                className="cls-3"
                style={cls3}
                d="M.1,0,0,11.176"
                transform="translate(-0.36 28.683)"
              />
              <path
                id="Path_14_Copy_4"
                dataName="Path 14 Copy 4"
                className="cls-3"
                style={cls3}
                d="M0,0,7.049,7.489"
                transform="translate(7.281 27.184)"
              />
            </g>
            <g
              id="Group_Copy"
              dataName="Group Copy"
              transform="translate(35.491 35.058) rotate(135)"
            >
              <path
                id="Path_14_Copy_3-2"
                dataName="Path 14 Copy 3"
                className="cls-3"
                style={cls3}
                d="M.278,0,0,11.554"
                transform="translate(0.712)"
              />
              <path
                id="Path_14_Copy_2-2"
                dataName="Path 14 Copy 2"
                className="cls-3"
                style={cls3}
                d="M.278,0,0,11.554"
                transform="translate(0 29.655)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Pointer
